export namespace Schema {
  export type Value =
    | 'string'
    | 'object'
    | 'enum'
    | 'array'
    | 'boolean'
    | 'integer'
    | 'number'
    | 'float'
    | 'null';

  export enum InputMetaType {
    Integration = 'integration',
    Inline = 'inline',
    Dynamic = 'dynamic',
  }

  export type NodeProperties = {
    title?: string;
    description?: string;
    isCollapsibleField?: boolean;
    logoUrl?: string;
    metaType?: InputMetaType;
    typeName?: string;
  };

  export enum Type {
    Field = 'field',
    Container = 'container',
    AnyOf = 'anyOf',
    Array = 'array',
  }

  export type FieldProperties = {
    name: string;
    title: string;
    pattern?: string;
    description?: string;
    type: Value;
    const?: string;
    /**
     * Enum options
     */
    options?: string[];
    items?: {
      type: Extract<Value, 'string' | 'number' | 'float' | 'integer'>;
    };
    required?: boolean;
    default?: any;
  };

  export type Container = NodeProperties & {
    type: Type.Container;
    name: string;
    children: Model[];
  };

  export type Field = NodeProperties & {
    type: Type.Field;
    name: string;
    properties: FieldProperties;
  };

  export type AnyOf = NodeProperties & {
    type: Type.AnyOf;
    name: string;
    children: Model[];
    default?: unknown;
  };

  export type Array = NodeProperties & {
    type: Type.Array;
    name: string;
    default?: any;
    children: Model[];
  };

  export type Model = Container | Field | AnyOf | Array;

  export type ModelWithChildren = Container | AnyOf;

  export type ModelWithoutChildren = Exclude<Model, ModelWithChildren>;

  export type CommonNodeProps = {
    name: FieldProperties['name'];
    error?: string;
    label?: FieldProperties['title'];
    note?: FieldProperties['description'];
    required?: FieldProperties['required'];
  };
}
